<template>
  <CustomDropdown
    name="time-selector"
    :value="value"
    :options="timeOptions"
    :placeholder="placeholder"
    :color="color"
    @input="onInput"
    :class="{'select-form': true}"
  />
</template>

<script>
import CustomDropdown from './CustomDropdown.vue'

export default {
  components: {
    CustomDropdown
  },
  props: {
    from: Number,
    to: Number,
    disabledfrom: Number,
    disabledto: Number,
    hour: [String, Number],
    extendedto: Number,
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      placeholder: 'Hora'
    }
  },
  computed: {
    value() {
      return this.hour ? parseInt(this.hour) : null
    },
    timeOptions() {
      return this.range().map(time => ({
        key: time.index,
        text: time.text,
        disabled: time.disabled
      }));
    }
  },
  methods: {
    onInput({ value }) {
      this.$emit('change', value);
    },
    range(){
      var range = [];
      // Regular hours
      for(var i = this.from; i <= this.to; i++ ){
        range.push({
          'index': i,
          'text': i + ':00',
          'disabled': (i < this.disabledfrom) || (i > this.disabledto),
        });
      }

      // Extended hours
      if (this.extendedto && this.extendedto > this.to) {
        for(var i = this.to + 1; i <= this.extendedto; i++ ){
          range.push({
            'index': i,
            'text': i + ':00' + '(AIRPORT)',
            'disabled': (i < this.disabledfrom) || (i > this.disabledto),
          });
        }
      }

      return range;
    }
  }
}
</script>

<style scoped>
/* Match the select-form appearance in FilterForm */
::v-deep .select-form .dropdown-selected {
    width: 100%;
}
</style>
